import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCheckinSearchResultRequest,
  failCheckinSearchResult,
  setCheckinSearchResult,
  setCheckinSearchResultFromApi,
  updateCheckinSearchResult,
  updateCheckinSearchResultFromApi,
} from './checkin-search-result.actions';

/**
 * Service to handle async CheckinSearchResult actions
 */
@Injectable()
export class CheckinSearchResultEffect {
  /**
   * Set the state with the reply content, dispatch failCheckinSearchResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCheckinSearchResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCheckinSearchResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failCheckinSearchResult({ error, requestId: action.requestId })),
        cancelCheckinSearchResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCheckinSearchResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCheckinSearchResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCheckinSearchResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failCheckinSearchResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
